import { useState } from "react";
import { Box } from "@mui/material";


const MyCarousel = ({title, items}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex === 0 ? items.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex === items.length - 1 ? 0 : prevIndex + 1));
  };

  const handleIndicatorClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div
      id='carousel'
      style={{
        width: '100%'
      }}
    >

    <div className="carousel slide"
    style={{ width: '100%'}}
    >
      {/* Indicators */}
      <ol className="carousel-indicators">
        {items.map((_, index) => (
          <li
            key={index}
            className={index === activeIndex ? "active" : ""}
            onClick={() => handleIndicatorClick(index)}
          ></li>
        ))}
      </ol>

      {/* Carousel Items */}
      <div className="carousel-inner"
        style={{width: '100%'}}
      >
        {items.map((item, index) => (
          <div
            key={index}
            className={`carousel-item ${index === activeIndex ? "active" : ""}`}
            style={{width: '100%'}}
          >
            <Box
              component={"img"}
              src={item.img}
              alt="img"
              sx={{
                width: "100%",
                height: {
                  sm: "50vh",
                  md: "90vh",
                },
                objectFit: "cover",
              }}
              ></Box>
            <div className="carousel-caption d-none d-md-block">
              <h5
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  padding: "10px",
                  color: "white",
                  borderRadius: "10px",
                }}
              >
                {item?.description}
              </h5>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Controls */}
      <a
        className="carousel-control-prev"
        href="#carousel"
        role="button"
        onClick={handlePrev}
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a
        className="carousel-control-next"
        href="#carousel"
        role="button"
        onClick={handleNext}
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
    </div>
  );
};

export default MyCarousel;